<template>
    <div v-if="visible">
        <el-drawer title="搜索文章" :visible.sync="visible"  :direction="direction" :before-close="handleClose" size="93%">
            <div class="drawer-body">
                <DatePicker @date-selected="handleDateSelection" @search="search(true)" />
                
                <div class="dialog-header">
                    <i class="el-icon-search"></i>
                    <input class="dialog-header-input" v-model="searchQuery" type="text" placeholder="请输入关键词,多个关键词需用英文逗号隔开" @keyup.enter="search(true)" />
                    <!-- <button class="search-btn" @click="search(true)">
                        <i class="el-icon-search"></i>
                    </button> -->
                </div>

                <div class="search-btn" @click="search(true)">
                    查 找
                </div>

                <!-- <div class="dialog-body">
                    <div v-for="(item, index) in dataList" :key="index" @click="goToArticle(item)" class="dialog-body-container">
                        <div style="width: 100%;">
                            <div class="dialog-body-container-title" v-html="item.highlightedTitle"></div>
                            <div class="dialog-body-container-text" v-html="item.highlightedContent"></div>
                        </div>
                    </div>
                    <p v-if="dataList.length < 1" style="margin: 2rem auto;color: #909399;font-weight: 300;font-size: 1.21rem;">暂无搜索结果 ～～</p>
                </div> -->

                <div class="dialog-body">
                    <div v-for="(item, index) in dataList" :key="index" @click="goToArticle(item)" class="dialog-body-container">
                        <span class="dialog-body-container-index">{{index + 1 + (page -1) * 20}}</span>

                        <div style="width: 88%;margin-right: 2%;">
                            <div class="dialog-body-container-title" v-html="item.highlightedTitle"></div>
                            <div class="dialog-body-container-text" v-html="item.highlightedContent"></div>
                        </div>
                    </div>
                    <p v-if="dataList.length < 1" style="margin: 2rem auto;color: #909399;font-weight: 300;font-size: 1.21rem;">暂无搜索结果 ～～</p>
                </div>

                <div class="dialog-footer">
                    <div v-if="total > 1" style="display: flex; align-items: center;">
                        <button class="page-btn" @click="prevPage" :disabled="page === 1">上一页</button>
                        <span style="margin: 0 .5rem;">{{ page }} / {{ Math.ceil(total / size) }}</span>
                        <button class="page-btn" @click="nextPage" :disabled="page >= Math.ceil(total / size)">下一页</button>
                    </div>
                    <span style="display: flex;align-items: center;">
                        <svg t="1756692621948" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3093" width="23" height="23"><path d="M798.723234 174.782745c0-60.576657-49.106418-109.683075-109.683075-109.683075l-354.708628 0c-60.576657 0-109.683075 49.106418-109.683075 109.683075l0 673.980161c0 60.576657 49.106418 109.683075 109.683075 109.683075l354.708628 0c60.576657 0 109.683075-49.106418 109.683075-109.683075L798.723234 174.782745zM264.557398 237.015112l494.256894 0 0 529.049305-494.256894 0L264.557398 237.015112zM334.356091 105.008612 689.016623 105.008612c38.548968 0 69.798692 31.249725 69.798692 69.798692l0 22.298865-494.256894 0 0-22.298865C264.557398 136.25936 295.807123 105.008612 334.356091 105.008612zM689.016623 918.53704 334.356091 918.53704c-38.548968 0-69.798692-31.249725-69.798692-69.798692l0-43.788296 494.256894 0 0 43.788296C758.814292 887.287315 727.564567 918.53704 689.016623 918.53704z" fill="#272636" p-id="3094"></path><path d="M513.173732 829.943282c-16.70752 0-30.30112 13.5936-30.30112 30.30112 0 16.70752 13.5936 30.30112 30.30112 30.30112s30.299073-13.5936 30.299073-30.30112C543.472805 843.536882 529.881253 829.943282 513.173732 829.943282z" fill="#272636" p-id="3095"></path></svg>
                        请上下滑动查看
                    </span>
                    <span> 关键词命中：{{ total }} 条</span>
                </div>

            </div>
        </el-drawer>
    </div>
</template>

<script>
import DatePicker from "./DatePickerMobile.vue";
import searchApi from "@/api/searchApi";
import getDeviceInfo from "@/utils/deviceInfo";

export default {
    components: {
        DatePicker,
    },
    props: {
        visible: Boolean,
    },
    data() {
        return {
            direction: "btt",
            searchQuery: "",
            dataList: [],
            page: 1,
            size: 20,
            total: 0,
            startDate: null,
            endDate: null,
            nowSearchRecordId: null,
        }
    },
    methods: {
          async goToArticle(item) {
            if (!this.nowSearchRecordId) return; // 如果没有记录ID，直接返回

            try {
                const dataForm = {
                    articleId: item.id
                }
                const res = await searchApi.clickArticle(this.nowSearchRecordId, dataForm);

                if (res.code === 200) {

                    window.open(
                        this.$router.resolve({
                            path: '/article',
                            query: { key: item.metadataName }
                        }).href,
                        '_blank'
                    )

          
                    // await this.closeDialog()
                } else {
                    console.error('点击文章失败:', res.message || '未知错误');
                    // 可选：提示用户
                    // this.$message.error(res.message || '加载文章失败，请重试');
                }
            } catch (error) {
                console.error('请求过程中发生错误:', error)
                // 可选：提示用户
                // this.$message.error('网络异常，请检查连接后重试');
            }
        },
        async search(resetPage = false) {
            if (resetPage) this.page = 1

            const deviceInfo = JSON.stringify(getDeviceInfo())
          
            const query = {
                query: this.searchQuery,
                page: this.page,
                pageSize: this.size,
                startDate: this.startDate, // 格式如 "2024-01-01"
                endDate: this.endDate,      // 格式如 "2024-12-31"
                uaInformation: deviceInfo
            }
            console.log(query)
            searchApi.search(query).then(res => {
                // this.dataList = res.data
                // this.totalPages = res.totalPages
                console.log(res.data.result)
                console.log(res.data.recordId)
                // this.dataList = res.data.result.hits
                this.nowSearchRecordId = res.data.recordId

                this.dataList = res.data.result.hits.map(item => {
                    return {
                        ...item,
                        highlightedTitle: item._formatted.title
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>'),
                        highlightedContent: item._formatted.content
                        .replace(/<em>/g, '<span style="color:green; font-weight:bold">')
                        .replace(/<\/em>/g, '</span>')
                    }
                })

                if(res.data.result.offset && res.data.result.offset  > 0) {
                    this.page = res.data.result.offset/res.data.result.limit + 1
                } else {
                    this.page = 1
                }
                this.size = res.data.result.limit;
                this.total = res.data.result.estimatedTotalHits;
            })
        },
        handleClose(done) {
            this.startDate = ''
            this.endDate = ''
            this.dataList= [],
            this.page= 1,
            this.size= 20,
            this.total= 0
            this.$emit("update:visible", false)
        },
        handleDateSelection(range) {
            console.log('选择的日期范围:', range)
            this.startDate =  range.start
            this.endDate =  range.end
            // 执行数据筛选等操作
        },
        prevPage() {
            if (this.page > 1) {
                this.page--
                this.search()
            }
        },
        nextPage() {
            if (this.page < (this.total / this.size)) {
                this.page++
                this.search();
            }
        },
    }
}
</script>

<style scoped lang="scss">
.drawer-body {
    padding: .8rem;
    padding-bottom: 2rem;
}

.dialog-header {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.dialog-header-input {
    width: 100%;
    max-width: 720px;
    padding: .7rem 0;
    padding-left: 1rem;
    border: none;
    border-bottom: .1rem #c8c8c8 solid;
    font-size: .9rem;
    margin: .7rem 0;
}

.dialog-header-input::-webkit-input-placeholder {
    color: #c8c8c8;
}
.dialog-header-input:-ms-input-placeholder {
    color: #c8c8c8;
}
.dialog-header-input::-ms-input-placeholder {
    color: #c8c8c8;
}
.dialog-header-input::placeholder {
    color: #c8c8c8;
}

.el-icon-search {
    color: #c8c8c8;
    position: absolute;
    left: 0;
}

.dialog-header-input:focus {
    border: none;
    border-bottom: .1rem #74c8a3 solid; /* 保持一致 */
    outline: none; /* 再次确保不出现蓝框 */
}

.search-btn {
    margin-left: .2rem;
    padding: .5rem;
    font-size: 1.22rem;
    background: #74c8a3;
    color: white;
    border: none;
    border-radius: 1.2rem 1.2rem 1.2rem 1.2rem;
    cursor: pointer;
    text-align: center;
}

.dialog-body {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    /* border-top: #88ba96 solid .05rem; */
    margin-top: 1rem;
    background: #ffffff;
    height: 100%;
    min-height: 34vh;
    max-height: 52vh;
    overflow: scroll;
    // padding: 1rem;
    box-sizing: border-box;
}

.dialog-body-container-index {
   width: 10%;
   color: green;
   font-weight: 700;
   font-size: 1.3rem;
   text-align: center;
}

// /* 滚动条整体 */
// .dialog-body::-webkit-scrollbar {
//     width: 4px; /* 垂直滚动条宽度 */
//     height: 0px; /* 水平滚动条高度 */
// }

// /* 滚动条滑块 */
// .dialog-body::-webkit-scrollbar-thumb {
//     background-color: #74c8a3;
//     border-radius: 4px;
// }

// /* 滚动条轨道 */
// .dialog-body::-webkit-scrollbar-track {
//     background: #f0f0f0;
//     border-radius: 4px;
// }

.dialog-body-container {
    width: 99%;
    padding: .7rem 0;
    background: white;
    border-radius: .5rem;
    min-height: 5.6rem;
    max-height: 6.2rem;
    max-width: 1068px;
    display: flex;
    align-items: center;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.17); /* 四边均衡阴影 */
    border: #f0f0f0 .003rem solid;
    margin: .3rem 0;
    cursor: pointer;
}

.dialog-body-container:hover {
    background: #74c8a3;
    color: white;

    .dialog-body-container-text {
        color: white;
    }
}

.dialog-body-container-title {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 2;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    // margin-bottom: .2rem;
    margin-top: 0;
    font-weight: 500;
    font-size: 1.02rem;
}

.dialog-body-container-text {
    display: -webkit-box;
    /* 使用弹性盒子模型，使得-webkit-line-clamp有效 */
    -webkit-box-orient: vertical;
    /* 子元素垂直排列 */
    -webkit-line-clamp: 3;
    /* 显示的行数 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 超出部分用省略号表示 */
    line-height: 1.5;
    /* 根据实际情况调整行高 */
    max-height: calc(1.5 * 2.8rem);
    /* 行高乘以显示的行数，确保最多显示两行 */
    margin-bottom: .2rem;
    margin-top: 0;
    font-size: .867rem;
    font-weight: 300;
    color: #909090;
}

.dialog-footer {
    position: absolute;
    bottom: 0;
    right: 0rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 1rem;
    background: white;
    width: calc(100% );
    box-sizing: border-box;
    padding: .5rem;
}

.page-btn {
    color: white;
    background: #74c8a3;
    border: none;
    border-radius: .22rem;
    padding: .2rem .5rem;
}


@media screen and (max-height: 700px) {
    .dialog-body {
        min-height: 34vh;
        max-height: 42vh;
    }
}
</style>